export default __webpack_public_path__ + "static/media/animaniacs-warner-bros.52e8518b.gif";